/* eslint-disable @typescript-eslint/naming-convention */
import parsePhoneNumberFromString, { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import { isValidEmail, isValidName, isValidZipCode } from '../../../../../Utils/validation';

export const validationSchema = (clientTagsRequired = false): any => {
  return Yup.object().shape({
    profile_img: Yup.string(),
    first_name: Yup.string().test('test-name', 'Enter Valid First Name', (value: any) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    middle_name: Yup.string().test('test-name', 'Enter Valid Last Name', (value: any) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    email: Yup.string()
      .required('Email is required')
      .test('test-name', 'Enter Valid Email', (value: any) => {
        if (value && !isValidEmail(value)) {
          return false;
        }
        return true;
      }),
    last_name: Yup.string().test('test-name', 'Enter Valid Last Name', (value: any) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    language: Yup.array(),
    phone_number: Yup.string().test('valid-us-phone', 'Enter Valid Phone Number', (value) => {
      // Optional → empty is allowed
      if (!value) return true;

      const phoneNumber = parsePhoneNumberFromString(value, 'US');

      return phoneNumber?.isValid() ?? false;
    }),
    zip_code: Yup.string().test('test-zip', 'Enter Valid Zip Code', (value: any) => {
      if (value && !isValidZipCode(value)) {
        return false;
      }
      return true;
    }),
    biography: Yup.string(),
    client_tag_ids: clientTagsRequired
      ? Yup.array()
          .transform((value, originalValue) => {
            if (Array.isArray(originalValue)) return originalValue;
            if (!originalValue || originalValue === '') return [];
            if (typeof originalValue === 'object') return [originalValue];
            return originalValue;
          })
          .min(1, 'Select at least one client tag')
          .required('Select at least one client tag')
      : Yup.array().of(Yup.string()),
  });
};
